import { useAppSelector } from "redux/hooks";
import { useFetch } from "hooks/api";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPGeo = (searchQueryFilter, geoLocationIdFilter = null) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const { data, isLoading } = useFetch(
    ["dspGeoLocations", searchQueryFilter, dspAdvertiser?.id],
    "/dsp/geo",
    {
      marketplace: marketPlace,
      geoLocationIdFilter: geoLocationIdFilter,
      textQuery: searchQueryFilter,
      nextToken: null,
      maxResults: 1000,
      dsp_seller_info_id: dspAdvertiser?.id,
    },
    {
      enabled: !!searchQueryFilter || !!geoLocationIdFilter?.length,
      select: (res) => {
        return res.data?.geoLocations ?? [];
      },
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
